const productData = [
  {
    id: 1,
    name: "Wrapped Up Bubble Waterproof Custom Cord Bracelet",
    price: "48.00",
    brand: "Bakimball",
    status: "available",
    discount: 25,
    images: [
      "/img/101.webp",
      "/img/101a.webp",
      "/img/101b.webp",
      "/img/101c.webp",
      "/img/101d.webp",
    ],
    description: [
      "The Wrapped Up Bubble bracelet is the perfect waterproof accessory for everyday wear and adventures.",
      "Featuring colorful bubble beads on a durable cord that can withstand water, sweat, and daily activities.",
      "Customize your bracelet with your choice of colors to match your personal style and wardrobe.",
      "This stackable design looks great worn alone or layered with other bracelets for a trendy stacked look.",
      "Made with high-quality waterproof materials that won't fade, ensuring long-lasting beauty.",
      "Perfect for beach vacations, pool days, gym sessions, or everyday casual wear.",
      "The adjustable cord closure ensures a comfortable fit for any wrist size.",
      "A fun and playful addition to your jewelry collection that adds a pop of color to any outfit.",
    ],
    features: [
      "100% waterproof and sweatproof design",
      "Colorful bubble beads in various color combinations",
      "Durable cord construction for long-lasting wear",
      "Adjustable sliding closure for perfect fit",
      "Stackable design for trendy layered looks",
      "Lightweight and comfortable for all-day wear",
      "Available in multiple color options",
      "Easy to clean - just rinse with water",
      "Perfect for active lifestyles",
      "Makes a great gift for friends and loved ones",
    ],
    category: "Bracelets",
  },
  {
    id: 2,
    name: "Janette Beaded Ring Necklace",
    price: "58.00",
    brand: "Bakimball",
    status: "available",
    images: ["/img/102.webp", "/img/102a.webp", "/img/102b.webp"],
    description: [
      "The Janette Beaded Ring Necklace is a stunning statement piece that combines bohemian charm with modern elegance.",
      "Features delicate beaded strands that cascade into a beautiful ring pendant design creating an eye-catching focal point.",
      "Hand-crafted with premium quality beads in various sizes and finishes for added dimension and texture.",
      "The adjustable chain length allows you to wear it as a choker or longer necklace to suit your style.",
      "Perfect for layering with other necklaces or wearing alone as a bold statement piece.",
      "This versatile design transitions seamlessly from casual daytime looks to elegant evening outfits.",
      "The ring element adds a unique architectural touch that sets this necklace apart from traditional beaded jewelry.",
      "Available in multiple colorways to complement any wardrobe and personal style preference.",
    ],
    features: [
      "Hand-crafted beaded design with ring pendant",
      "Premium quality beads with varied finishes",
      "Adjustable chain length for versatile styling",
      "Lightweight and comfortable for all-day wear",
      "Lobster clasp closure for secure wear",
      "Nickel-free and hypoallergenic materials",
      "Perfect for layering or wearing solo",
      "Available in multiple color options",
      "Adds texture and dimension to any outfit",
      "Makes a thoughtful gift for jewelry lovers",
    ],
    category: "Necklaces",
  },
  {
    id: 3,
    name: "Gold Cubic Zirconia Custom Birthstone Ring",
    price: "68.00",
    brand: "Bakimball",
    status: "available",
    discount: 25,
    size: ["5", "6", "7", "8", "9"],
    images: [
      "/img/103.webp",
      "/img/103a.webp",
      "/img/103b.webp",
      "/img/103c.webp",
    ],
    description: [
      "The Gold Cubic Zirconia Custom Birthstone Ring is a personalized treasure that celebrates your unique story.",
      "Features brilliant cubic zirconia stones that sparkle like genuine gemstones at a fraction of the cost.",
      "Customize with your birthstone or choose your favorite stone color to create a truly personal piece.",
      "Crafted in lustrous gold-tone metal with a classic yet contemporary design that never goes out of style.",
      "The adjustable band ensures a comfortable fit for any finger size and allows for flexible wearing options.",
      "Perfect for stacking with other rings or wearing as a standalone statement piece.",
      "Makes a meaningful gift for birthdays, anniversaries, or any special milestone celebration.",
      "The high-quality cubic zirconia stones are cut to maximize brilliance and fire.",
    ],
    features: [
      "Customizable with birthstone color of your choice",
      "High-quality cubic zirconia stones with brilliant sparkle",
      "Gold-tone metal construction with durable finish",
      "Adjustable band for perfect fit",
      "Hypoallergenic and nickel-free materials",
      "Stackable design for trendy layered looks",
      "Comfortable for everyday wear",
      "Available in all 12 birthstone colors",
      "Tarnish-resistant coating for long-lasting beauty",
      "Comes in elegant gift-ready packaging",
    ],
    category: "Rings",
  },
  {
    id: 4,
    name: "Lexi Crystal Collar Necklace",
    price: "78.00",
    brand: "Bakimball",
    status: "available",
    images: ["/img/104.webp", "/img/104a.webp", "/img/104b.webp"],
    description: [
      "The Lexi Crystal Collar Necklace is a glamorous statement piece that adds instant sophistication to any outfit.",
      "Features an array of brilliant crystals arranged in an elegant collar design that frames the neckline beautifully.",
      "Each crystal is carefully set to catch and reflect light from every angle, creating maximum sparkle.",
      "The structured collar shape provides a modern twist on classic crystal jewelry designs.",
      "Perfect for transforming a simple outfit into a show-stopping ensemble for special occasions.",
      "Ideal for weddings, parties, date nights, or any event where you want to make a memorable impression.",
      "The adjustable chain allows you to customize the fit and styling to your preference.",
      "This versatile piece works equally well with formal gowns or elevated casual wear.",
    ],
    features: [
      "Stunning crystal collar design with brilliant stones",
      "Adjustable chain for customizable fit",
      "Secure lobster clasp closure",
      "Lightweight construction for comfortable wear",
      "Nickel-free and hypoallergenic materials",
      "Statement-making design perfect for special occasions",
      "Hand-set crystals for maximum sparkle",
      "Versatile styling from formal to dressy casual",
      "Tarnish-resistant metal finish",
      "Makes an impressive gift for jewelry enthusiasts",
    ],
    category: "Necklaces",
  },
  {
    id: 5,
    name: "Toi et Moi Custom Birthstone Ring",
    price: "72.00",
    brand: "Bakimball",
    status: "available",
    size: ["5", "6", "7", "8", "9", "10"],
    images: [
      "/img/105.webp",
      "/img/105a.webp",
      "/img/105b.webp",
      "/img/105c.webp",
      "/img/105d.webp",
    ],
    description: [
      "The Toi et Moi Custom Birthstone Ring features the romantic 'you and me' design symbolizing two souls intertwined.",
      "Showcases two beautiful birthstones side by side, representing you and your loved one in perfect harmony.",
      "Customize with any combination of birthstones to create a deeply personal and meaningful piece.",
      "The classic toi et moi design has been beloved for centuries, famously worn by Napoleon's Josephine.",
      "Crafted with high-quality materials and brilliant stones that catch the light beautifully.",
      "Perfect as an engagement ring alternative, anniversary gift, or symbol of friendship and love.",
      "The adjustable band ensures a comfortable fit and allows you to wear it on any finger.",
      "Each stone is carefully selected and set to showcase its unique color and brilliance.",
    ],
    features: [
      "Classic toi et moi 'you and me' design",
      "Customizable with two birthstones of your choice",
      "High-quality stones with brilliant color",
      "Adjustable band for perfect fit",
      "Gold-tone or silver-tone metal options",
      "Hypoallergenic and nickel-free materials",
      "Romantic symbolism perfect for gifting",
      "Available in all birthstone combinations",
      "Comfortable for everyday wear",
      "Comes with beautiful gift packaging",
    ],
    category: "Rings",
  },

  {
    id: 6,
    name: "Bianca 18K Gold Earrings",
    price: "118.00",
    brand: "Bakimball",
    status: "available",
    images: ["/img/106.webp", "/img/106a.webp"],
    description: [
      "The Bianca 18K Gold Earrings are luxurious demi-fine jewelry pieces that elevate any look with timeless elegance.",
      "Crafted from genuine 18K gold plating over sterling silver for lasting beauty and durability.",
      "Features a sophisticated design that balances modern style with classic appeal.",
      "The high-quality construction ensures these earrings will be treasured pieces in your collection for years.",
      "Perfect for daily wear or special occasions, these versatile earrings complement any outfit.",
      "The hypoallergenic materials make them suitable for even the most sensitive ears.",
      "Designed to catch the light beautifully while maintaining an understated elegance.",
      "A perfect gift for yourself or someone special who appreciates fine jewelry quality.",
    ],
    features: [
      "Genuine 18K gold plating over sterling silver",
      "Demi-fine jewelry quality construction",
      "Hypoallergenic and safe for sensitive ears",
      "Nickel-free materials for comfort",
      "Secure push-back or lever-back closures",
      "Lightweight design for all-day comfort",
      "Tarnish-resistant with proper care",
      "Versatile style for everyday or special occasions",
      "Comes in luxurious jewelry packaging",
      "Investment-quality piece that lasts",
    ],
    category: "Earrings",
  },
  {
    id: 7,
    name: "Groovy Letter Custom Hinge Bangle",
    price: "58.00",
    brand: "Bakimball",
    status: "available",
    size: ["S", "M", "L"],
    images: ["/img/107.webp", "/img/107a.webp"],
    description: [
      "The Groovy Letter Custom Hinge Bangle brings retro vibes with a personalized touch to your wrist.",
      "Features fun, groovy-style letters that can be customized to spell out your name, initials, or meaningful word.",
      "The convenient hinge design makes it easy to put on and take off without struggling with clasps.",
      "Crafted with high-quality materials and a smooth finish that feels comfortable against your skin.",
      "Perfect for adding a playful, personalized element to your everyday jewelry rotation.",
      "The chunky bangle design makes a bold statement while remaining lightweight and wearable.",
      "Ideal for stacking with other bracelets or wearing solo as a standout piece.",
      "A fun gift idea for friends, family, or yourself to celebrate individual style and personality.",
    ],
    features: [
      "Customizable with groovy-style letters",
      "Easy-to-use hinge opening for convenience",
      "Smooth, comfortable interior finish",
      "Bold bangle design with retro appeal",
      "Lightweight construction for all-day wear",
      "Tarnish-resistant metal finish",
      "Available in gold and silver tones",
      "Perfect for stacking or solo wear",
      "Hypoallergenic materials",
      "Makes a unique personalized gift",
    ],
    category: "Bracelets",
  },

  {
    id: 8,
    name: "Joan Semi-Precious Necklace",
    price: "88.00",
    brand: "Bakimball",
    status: "available",
    images: ["/img/108.webp", "/img/108a.webp", "/img/108b.webp"],
    description: [
      "The Joan Semi-Precious Necklace features genuine semi-precious stones that bring natural beauty to your jewelry collection.",
      "Each stone is hand-selected for its unique color, pattern, and quality, making every necklace truly one-of-a-kind.",
      "The elegant design showcases the natural beauty of the gemstones while creating a sophisticated look.",
      "Semi-precious stones have been valued for centuries for both their beauty and believed healing properties.",
      "Perfect for adding a touch of natural elegance to both casual and dressy outfits.",
      "The adjustable chain length allows you to wear it at your preferred position on the neckline.",
      "Each stone's natural variations in color and pattern make your piece authentically unique.",
      "A meaningful gift that combines natural beauty with timeless jewelry design.",
    ],
    features: [
      "Genuine semi-precious gemstones",
      "Hand-selected stones for quality",
      "Each piece is naturally unique",
      "Adjustable chain length",
      "Secure lobster clasp closure",
      "Gold or silver-tone metal options",
      "Hypoallergenic materials",
      "Versatile design for any occasion",
      "Natural stone with believed healing properties",
      "Comes with stone information card",
    ],
    category: "Necklaces",
  },

  {
    id: 9,
    name: "Barbra 18K Gold Pearl Earrings",
    price: "128.00",
    brand: "Bakimball",
    status: "available",
    images: ["/img/109.webp", "/img/109a.webp"],
    description: [
      "The Barbra 18K Gold Pearl Earrings combine the timeless elegance of pearls with luxurious gold craftsmanship.",
      "Features lustrous pearls that have symbolized elegance and sophistication for centuries.",
      "Crafted with genuine 18K gold plating over sterling silver for a luxurious, long-lasting finish.",
      "The classic pearl and gold combination makes these earrings perfect for any formal or special occasion.",
      "Each pearl is carefully selected for its shape, luster, and quality to ensure perfection.",
      "These demi-fine earrings are investment pieces that will remain timeless in your collection.",
      "The sophisticated design complements everything from business attire to evening gowns.",
      "A perfect gift for graduations, weddings, birthdays, or any milestone celebration.",
    ],
    features: [
      "Genuine 18K gold plating over sterling silver",
      "High-quality lustrous pearls",
      "Demi-fine jewelry construction",
      "Hypoallergenic and nickel-free",
      "Secure post and push-back closures",
      "Timeless design that never goes out of style",
      "Lightweight and comfortable for extended wear",
      "Versatile for formal and professional settings",
      "Comes in elegant jewelry packaging",
      "Perfect bridal or special occasion jewelry",
    ],
    category: "Earrings",
  },

  {
    id: 10,
    name: "Mini Semi-Precious Custom Necklace",
    price: "78.00",
    brand: "Bakimball",
    status: "available",
    images: ["/img/1010.webp", "/img/1010a.webp"],
    description: [
      "The Mini Semi-Precious Custom Necklace combines the beauty of natural gemstones with personalized style.",
      "Features delicate, genuine semi-precious stones in a smaller, more subtle size perfect for layering.",
      "Can be customized with your choice of stone type and arrangement for a truly personal piece.",
      "Each semi-precious stone is hand-selected and carries its own unique natural characteristics.",
      "The dainty design makes it perfect for everyday wear or as part of a curated necklace stack.",
      "Natural stones have been cherished throughout history for their beauty and believed metaphysical properties.",
      "The adjustable chain allows you to find your perfect length for various necklines.",
      "A meaningful gift that celebrates individuality and natural beauty.",
    ],
    features: [
      "Genuine mini semi-precious gemstones",
      "Customizable stone selection",
      "Delicate design perfect for layering",
      "Adjustable chain length",
      "Each stone is naturally unique",
      "Gold or silver-tone chain options",
      "Hypoallergenic materials",
      "Secure lobster clasp closure",
      "Lightweight and comfortable",
      "Includes stone meaning card",
    ],
    category: "Necklaces",
  },

  {
    id: 11,
    name: "Thalia Mariner Chain Bracelet",
    price: "68.00",
    brand: "Bakimball",
    status: "available",
    size: ['6.5"', '7"', '7.5"', '8"'],
    images: ["/img/1011.webp", "/img/1011a.webp"],
    description: [
      "The Thalia Mariner Chain Bracelet features a classic nautical-inspired design with modern sophistication.",
      "The mariner chain, also known as an anchor chain, has been a jewelry staple for its timeless appeal.",
      "Each link is carefully crafted to create a smooth, flexible bracelet that drapes beautifully on the wrist.",
      "The substantial chain design makes a bold statement while remaining versatile enough for everyday wear.",
      "Perfect for those who appreciate classic jewelry styles with a contemporary edge.",
      "The secure clasp ensures your bracelet stays safely on your wrist throughout the day.",
      "Can be worn alone as a statement piece or stacked with other bracelets for a layered look.",
      "A unisex design that makes an excellent gift for anyone who loves quality jewelry.",
    ],
    features: [
      "Classic mariner chain design",
      "High-quality metal construction",
      "Smooth, flexible links for comfort",
      "Substantial weight feels luxurious",
      "Secure lobster clasp closure",
      "Tarnish-resistant finish",
      "Available in gold and silver tones",
      "Unisex styling",
      "Perfect for stacking or solo wear",
      "Adjustable sizing options",
    ],
    category: "Bracelets",
  },
  {
    id: 12,
    name: "Toi et Moi 18K Gold Custom Birthstone Necklace",
    price: "148.00",
    brand: "Bakimball",
    status: "available",
    images: ["/img/1012.webp", "/img/1012a.webp"],
    description: [
      "The Toi et Moi 18K Gold Custom Birthstone Necklace celebrates the 'you and me' romantic French design.",
      "Features two birthstones of your choice, representing two souls coming together in perfect harmony.",
      "Crafted with genuine 18K gold plating over sterling silver for luxurious, lasting quality.",
      "Each birthstone is carefully selected for its color, clarity, and symbolism.",
      "The Toi et Moi style has been beloved since the 18th century, made famous by Napoleon's engagement ring.",
      "Perfect for celebrating relationships, anniversaries, family bonds, or personal milestones.",
      "Customize with your birthstone and that of a loved one for a truly meaningful piece.",
      "A romantic and thoughtful gift that tells a unique love story.",
    ],
    features: [
      "Genuine 18K gold plating over sterling silver",
      "Two customizable birthstones",
      "Demi-fine jewelry quality",
      "Classic Toi et Moi design",
      "High-quality genuine or simulated birthstones",
      "Adjustable chain length",
      "Hypoallergenic and nickel-free",
      "Secure lobster clasp closure",
      "Comes with birthstone meaning card",
      "Perfect romantic or anniversary gift",
    ],
    category: "Necklaces",
  },
  {
    id: 13,
    name: "Fine Line Custom iPhone Case",
    price: "48.00",
    brand: "Bakimball",
    status: "available",
    images: ["/img/1013.webp", "/img/1013a.webp"],
    description: [
      "The Fine Line Custom iPhone Case combines sleek minimalist design with personalized style.",
      "Features delicate, fine line artwork that can be customized with names, initials, or meaningful words.",
      "The slim profile protects your phone without adding bulk to your pocket or purse.",
      "High-quality materials provide durable protection against everyday drops, scratches, and wear.",
      "The elegant design makes your phone an extension of your personal style.",
      "Perfect for those who appreciate understated sophistication in their tech accessories.",
      "Wireless charging compatible so you never have to remove the case.",
      "A thoughtful gift that's both practical and beautifully personalized.",
    ],
    features: [
      "Customizable with fine line text or design",
      "Slim, lightweight profile",
      "Durable shock-absorbing materials",
      "Raised edges protect screen and camera",
      "Wireless charging compatible",
      "Precise cutouts for all ports and buttons",
      "Easy snap-on installation",
      "Available for multiple iPhone models",
      "Scratch-resistant finish",
      "Makes a unique personalized gift",
    ],
    category: "Accessories",
  },
  {
    id: 14,
    name: "Mini Pavé Script Cluster Custom Nameplate Necklace",
    price: "98.00",
    brand: "Bakimball",
    status: "available",
    images: ["/img/1014.webp", "/img/1014a.webp"],
    description: [
      "The Mini Pavé Script Cluster Custom Nameplate Necklace is a dazzling personalized piece adorned with sparkle.",
      "Features delicate pavé-set crystals or diamonds that catch the light beautifully around your custom nameplate.",
      "The elegant script font adds a touch of sophistication to this personalized jewelry piece.",
      "Each crystal is meticulously hand-set to create maximum sparkle and brilliance.",
      "Perfect for wearing your own name, a loved one's name, or a meaningful word close to your heart.",
      "The clustered crystal design creates the illusion of a larger, more luxurious piece.",
      "An elevated take on the classic nameplate necklace with added glamour and shine.",
      "A stunning gift that shows thoughtfulness and celebrates individual identity with sparkle.",
    ],
    features: [
      "Custom nameplate in elegant script font",
      "Pavé crystals or diamonds hand-set for sparkle",
      "Delicate mini size perfect for layering",
      "High-quality metal construction",
      "Adjustable chain length",
      "Secure lobster clasp closure",
      "Available in gold, rose gold, and silver tones",
      "Hypoallergenic materials",
      "Tarnish-resistant finish",
      "Comes in luxurious gift packaging",
    ],
    category: "Necklaces",
  },
  {
    id: 15,
    name: "Thalia Necklace",
    price: "78.00",
    brand: "Bakimball",
    status: "available",
    images: ["/img/1015.webp", "/img/1015a.webp"],
    description: [
      "The Thalia Necklace is a timeless piece that brings effortless elegance to any neckline.",
      "Features a refined design that balances classic beauty with contemporary style.",
      "The high-quality construction ensures this necklace will be a cherished piece for years to come.",
      "Versatile enough to wear daily yet special enough for important occasions.",
      "The perfect length hits at the ideal spot on the neckline for a flattering look.",
      "Pairs beautifully with other necklaces for a layered look or stunning on its own.",
      "A staple piece that complements everything from casual tees to elegant evening wear.",
      "An ideal gift for anyone who appreciates timeless, quality jewelry.",
    ],
    features: [
      "Timeless elegant design",
      "High-quality metal construction",
      "Perfect length for versatile styling",
      "Adjustable chain for custom fit",
      "Secure lobster clasp closure",
      "Tarnish-resistant finish",
      "Available in gold and silver tones",
      "Lightweight and comfortable",
      "Perfect for layering or solo wear",
      "Hypoallergenic materials",
    ],
    category: "Necklaces",
  },

  {
    id: 16,
    name: "Initial Custom Medallion Necklace",
    price: "88.00",
    brand: "Bakimball",
    status: "available",
    images: ["/img/1016.webp", "/img/1016a.webp"],
    description: [
      "The Initial Custom Medallion Necklace features a bold, coin-style pendant personalized with your chosen initial.",
      "The medallion design has been a jewelry staple throughout history, symbolizing identity and heritage.",
      "Features raised or engraved initial detailing that creates a sophisticated, vintage-inspired look.",
      "The substantial medallion size makes a statement while remaining elegant and wearable.",
      "Perfect for wearing your own initial or that of someone special close to your heart.",
      "The timeless medallion style ensures this piece will never go out of fashion.",
      "Pairs beautifully with both casual and dressy outfits for versatile styling.",
      "A meaningful personalized gift that celebrates individual identity with classic style.",
    ],
    features: [
      "Custom initial medallion pendant",
      "Bold coin-style design",
      "Raised or engraved detailing",
      "High-quality metal construction",
      "Substantial yet lightweight pendant",
      "Adjustable chain length",
      "Secure lobster clasp closure",
      "Available in gold, rose gold, and silver",
      "Tarnish-resistant finish",
      "Timeless vintage-inspired aesthetic",
    ],
    category: "Necklaces",
  },
  {
    id: 17,
    name: "Organic Letter Custom Necklace",
    price: "68.00",
    brand: "Bakimball",
    status: "available",
    images: ["/img/1017.webp", "/img/1017a.webp"],
    description: [
      "The Organic Letter Custom Necklace features free-flowing, naturally-shaped letterforms for a modern, artistic look.",
      "Each letter has an organic, hand-drawn quality that sets it apart from traditional block or script styles.",
      "The irregular, natural shapes give this personalized necklace a unique contemporary aesthetic.",
      "Perfect for those who appreciate modern design and want their jewelry to reflect artistic sensibility.",
      "Customize with initials, a name, or meaningful word in this distinctive organic style.",
      "The asymmetric letterforms create visual interest and conversation-starting appeal.",
      "Lightweight and comfortable enough for daily wear while making a style statement.",
      "A unique gift for the person who appreciates art, design, and individuality.",
    ],
    features: [
      "Organic, free-form letter shapes",
      "Customizable with names or initials",
      "Modern artistic aesthetic",
      "Lightweight construction",
      "High-quality metal",
      "Adjustable chain length",
      "Secure lobster clasp",
      "Available in gold and silver tones",
      "Contemporary design",
      "Perfect for minimalist style lovers",
    ],
    category: "Necklaces",
  },
  {
    id: 18,
    name: "Rebecca Door Knocker Earrings",
    price: "58.00",
    brand: "Bakimball",
    status: "available",
    images: ["/img/1018.webp", "/img/1018a.webp"],
    description: [
      "The Rebecca Door Knocker Earrings feature a bold, vintage-inspired hoop design reminiscent of classic door hardware.",
      "The door knocker style has been a fashion statement since the 1980s and continues to be timelessly chic.",
      "These substantial hoops make a confident statement while remaining surprisingly lightweight and comfortable.",
      "The polished finish catches light beautifully, adding glamour to any look from casual to dressy.",
      "Perfect for those who love bold, architectural jewelry with a nod to vintage style.",
      "The secure closure ensures these statement earrings stay safely in place all day.",
      "Versatile enough to pair with everything from jeans and a tee to evening wear.",
      "A modern classic that adds instant polish and confidence to your ensemble.",
    ],
    features: [
      "Bold door knocker hoop design",
      "Lightweight despite substantial appearance",
      "High-quality metal construction",
      "Polished finish for maximum shine",
      "Secure closure mechanism",
      "Available in gold and silver tones",
      "Hypoallergenic materials",
      "Comfortable for extended wear",
      "Vintage-inspired aesthetic",
      "Statement-making yet versatile",
    ],
    category: "Earrings",
  },
  {
    id: 19,
    name: "Heather 18K Gold Earrings",
    price: "108.00",
    brand: "Bakimball",
    status: "available",
    images: ["/img/1019.webp", "/img/1019a.webp"],
    description: [
      "The Heather 18K Gold Earrings are sophisticated demi-fine pieces that bring luxury to your everyday style.",
      "Crafted with genuine 18K gold plating over sterling silver for lasting beauty and quality.",
      "The elegant design strikes the perfect balance between classic and contemporary aesthetics.",
      "These versatile earrings transition seamlessly from office to evening, casual to formal.",
      "The high-quality construction ensures these will be treasured staples in your jewelry collection.",
      "Designed to complement a wide range of face shapes and personal styles.",
      "The lustrous gold finish catches light beautifully without being overly flashy.",
      "An investment piece that offers demi-fine quality at an accessible price point.",
    ],
    features: [
      "Genuine 18K gold plating over sterling silver",
      "Demi-fine jewelry quality",
      "Versatile design for any occasion",
      "Hypoallergenic and nickel-free",
      "Secure post or hook closures",
      "Lightweight and comfortable",
      "Tarnish-resistant with proper care",
      "Elegant yet understated design",
      "Suitable for sensitive ears",
      "Comes in premium packaging",
    ],
    category: "Earrings",
  },
  {
    id: 20,
    name: "Quinn Collar Necklace",
    price: "78.00",
    brand: "Bakimball",
    status: "available",
    images: ["/img/1020.webp", "/img/1020a.webp"],
    description: [
      "The Quinn Collar Necklace is a bold statement piece that elevates any neckline with sophisticated style.",
      "This modern collar design hugs the neck beautifully, creating a sleek and polished look.",
      "The structured silhouette adds instant drama and elegance to both casual and dressy outfits.",
      "Crafted with attention to detail, this collar necklace is surprisingly comfortable and lightweight.",
      "Perfect for adding edge to a simple top or complementing an elegant dress or blazer.",
      "The adjustable closure ensures a perfect fit for various neck sizes and styling preferences.",
      "A versatile statement piece that works for everything from brunch to evening events.",
      "The Quinn Collar is for the confident woman who loves making a bold fashion statement.",
    ],
    features: [
      "Bold collar necklace design",
      "Structured yet lightweight construction",
      "High-quality metal finish",
      "Adjustable closure for perfect fit",
      "Available in gold and silver tones",
      "Comfortable for extended wear",
      "Modern architectural aesthetic",
      "Statement-making yet versatile",
      "Pairs well with various necklines",
      "Adds instant sophistication to any outfit",
    ],
    category: "Necklaces",
  },
];

export default productData;
